class ResultItem {
    constructor(title, url, body = '', image = '') {
        this.title = title;
        this.url = url;
        this.body = body;
        this.image = image;
    }
}

export default ResultItem;
